export default "__VITE_ASSET__DPhTHuc1__"